import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { Modal } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";

/* Services */
import { api } from "../../../../services/api/api";
import Loading from "../../../../components/loading/Loading";
/***/

/**
* DeleteMachineModal: display machine deletion modal
* @param open - modal open state
* @param machine - machine to delete
* @param onDelete - callback after deletion
* @param onClose - callback to close modal
*/
export default function DeleteMachineModal({
  open,
  machine,
  onDelete,
  onClose
}: {
  open: boolean,
  machine: EasyTech.Machine,
  onDelete: () => void
  onClose: () => void
}) {
  const [delLoad, setDelLoad] = useState<boolean>(false); 
  
  const deleteMachine = () => {
    setDelLoad(true);
    api.delete(`users/machines/disable/${machine.id}`, {})
      .then((ret) => {
        toast.success(t("workorder:machines:success:machineRemoved"));
        onDelete();
      }).catch((err) => {
        toast.error(t("workorder:machines:error:machineRemoveError"));
      }).finally(() => {
        onClose();
      });
  };
  
  return(
    <Modal
      open={open}
      onClose={onClose}
      className="te-modal"
      aria-labelledby="te-modal"
      aria-describedby="te-modal">
      <Card className="te-modal-content rounded-lg">
        <button className="close-button" onClick={() => onClose()}>
          <XMarkIcon className="w-4"/>
        </button>
        <CardBody>
          <div className="flex items-center gap-3 mb-5">
            <div className="rounded-full border p-2 bg-red-200">
              <TrashIcon className="w-7 text-red-700" /> 
            </div>
            <Typography variant="h5">
              {t("workorder:machines:delete:title", {serialNumber: machine.serialNumber})}
            </Typography>
          </div>
         
          <Typography variant="paragraph">
            {t("workorder:machines:delete:description")}
          </Typography>
        </CardBody>
        <CardFooter className="pt-0 flex gap-2 justify-end">
          <Button variant="outlined"
                  onClick={onClose}>
            {t("common:cancel")}
          </Button>

          {delLoad ?
            <Loading />
            :
            <>
              <Button color="red"
                      onClick={() => deleteMachine()}>
                {t("common:delete")}
              </Button>
            </>
          }
        </CardFooter>
      </Card>
    </Modal>
  );
}
/***/ 